import { Checkbox } from 'antd';
import styled from 'styled-components';

export const TemporaryClosureControl = styled(Checkbox)`
  color: ${props => props.theme.colors.shade2};
  margin-left: 42.5%;
  margin-bottom: 10px;
`;
